import React, { useEffect } from 'react';
import { usePageVisibility } from 'react-page-visibility';

import MyTeam from './components/myTeam/MyTeam';
import AllocationCard from './components/allocationCard/AllocationCard';
import { NoticeAndEvents } from './components/noticeAndEvents/NoticeAndEvents';

import * as mixpanel from 'services/mixPanel';

import { mixPanelEvents } from 'constants/mixPanel';
import type { Designation } from 'interface/designation';

import useCurrentFiscalYear from 'hooks/useCurrentFiscalYear';
import WorkStatusColumn from './components/workStatus/WorkStatusColumn';

interface DashboardUser {
  id: number | string;
  country?: string;
  designation?: Designation;
}

interface DashboardProps {
  user: DashboardUser;
}

interface FiscalYearLike {
  startDate?: string;
  endDate?: string;
}

const Dashboard: React.FC<DashboardProps> = (props) => {
  useEffect(() => {
    window.document.title = 'Vyaguta';
  }, []);

  const isVisible = usePageVisibility();
  const currentFiscalYear: FiscalYearLike = useCurrentFiscalYear();

  useEffect(() => {
    const event = isVisible ? mixPanelEvents.view.dashboard : mixPanelEvents.switch.from.dashboard;

    mixpanel.trackEvent(event);
  }, [isVisible]);

  return (
    <div className="container dashboard">
      <div className="dashboard__contents">
        <AllocationCard userId={props.user.id} designation={props?.user?.designation} />

        {/* <DashboardCard className="actions" title="Attendance Information">
          <PendingActions userId={props.user.id} designation={props?.user?.designation} />
        </DashboardCard> */}

        {/* <DashboardCard className="full-scope-card dashboard__card leave-plan-card" title="Team's Leave Plan">
          <LeavePlanCard userId={props.user.id} />
        </DashboardCard> */}

        <WorkStatusColumn />

        <NoticeAndEvents currentFiscalYear={currentFiscalYear} />

        <div className="full-scope-card dashboard__card my-team">
          <MyTeam user={props?.user} />
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
